export default __webpack_public_path__ + "static/media/maintenance.6a14e973.svg";